import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import permissionService from "../services/permission";

const initialState = {
  role: '',
  permission: []
};

export const getPermission = createAsyncThunk(
  "permission/get",
  async (permissionInfo) => {
    const res = await permissionService.getPermission(permissionInfo);
    return res.data;
  }
)

export const savePermission = createAsyncThunk(
  "permission/save",
  async (permissionInfo) => {
    const res = await permissionService.savePermission(permissionInfo);
    return res.data;
  }
);

const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    changePermission: (state, action) => {
      const {module, kind} = action.payload;
      const newData =  state.permission.map(item => {
        if(item.module === module) {
          return {...item, [kind]: !item[kind]}
        }
        return item;
      });
      state.permission = newData;
    },
    changeRole: (state, action) => {
      const {role} = action.payload;
      state.role = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(savePermission.fulfilled, (state, action) => {})
    builder.addCase(getPermission.fulfilled, (state, action) => {
      const {name, permission} = action.payload;
      state.role = name;
      state.permission = JSON.parse(permission);
    })
  }
})

export const {
  changePermission, 
  changeRole
} = permissionSlice.actions;

const { reducer } = permissionSlice;
export default reducer;